import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";

export type ScheduleMode = "picker" | "legacy";

const TABS: { value: ScheduleMode; labelKey: string }[] = [
	{ value: "picker", labelKey: "mode_toggle.picker" },
	{ value: "legacy", labelKey: "mode_toggle.legacy" },
];

/**
 * Per-visit selector between the new calendar picker and the old therapist
 * search. Rendered only when the schedule-picker freedom flag is on. Styled as
 * an underline tab bar: the active mode gets a coloured underline, the other is
 * muted.
 */
export function ScheduleModeToggle({
	value,
	onChange,
}: {
	value: ScheduleMode;
	onChange: (mode: ScheduleMode) => void;
}) {
	const { t } = useTranslation("appointments-form", {
		keyPrefix: "appt_schedule.schedule_picker",
	});
	return (
		<div className="col-span-full flex gap-4 border-b" role="tablist">
			{TABS.map((tab) => {
				const active = value === tab.value;
				return (
					<button
						key={tab.value}
						type="button"
						role="tab"
						aria-selected={active}
						onClick={() => onChange(tab.value)}
						className={cn(
							"-mb-px border-b-2 px-1 pb-2 text-sm font-medium transition-colors",
							active
								? "border-primary text-foreground"
								: "border-transparent text-muted-foreground hover:text-foreground",
						)}
					>
						{t(tab.labelKey)}
					</button>
				);
			})}
		</div>
	);
}
